<template>
  <div class="rounded-[14px] border border-slate-200 bg-white">
    <div class="grid gap-0 xl:grid-cols-[minmax(0,1.55fr)_minmax(320px,0.95fr)]">
      <section class="px-5 py-4 xl:border-r xl:border-slate-200">
        <div class="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">
          Resumo do Pedido
        </div>

        <div class="mt-3 space-y-3">
          <div>
            <div class="text-[11px] font-medium uppercase tracking-[0.08em] text-slate-400">
              Pedido
            </div>
            <div class="mt-1 text-[18px] font-semibold leading-6 text-[#13161b]">
              {{ summary?.orderName || '-' }}
            </div>
          </div>

          <div class="grid gap-3 md:grid-cols-2">
            <div class="min-w-0">
              <div class="text-[11px] font-medium uppercase tracking-[0.08em] text-slate-400">
                Cliente
              </div>
              <div class="mt-1 text-[14px] font-semibold leading-5 text-[#13161b]">
                {{ summary?.clientName || '-' }}
              </div>
            </div>

            <div class="min-w-0">
              <div class="text-[11px] font-medium uppercase tracking-[0.08em] text-slate-400">
                Oportunidade
              </div>
              <div class="mt-1 text-[14px] font-semibold leading-5 text-[#13161b]">
                {{ summary?.opportunityName || '-' }}
              </div>
            </div>
          </div>

          <div class="grid gap-3 md:grid-cols-[minmax(0,1fr)_180px]">
            <div class="min-w-0">
              <div class="text-[11px] font-medium uppercase tracking-[0.08em] text-slate-400">
                Proposta
              </div>
              <div class="mt-1 text-[14px] font-semibold leading-5 text-[#13161b]">
                {{ summary?.quoteNumber || '-' }}
              </div>
            </div>

            <div class="min-w-0">
              <div class="text-[11px] font-medium uppercase tracking-[0.08em] text-slate-400">
                Moeda
              </div>
              <div class="mt-1 text-[14px] font-semibold leading-5 text-[#13161b]">
                {{ summary?.currencyLabel || summary?.currencyCode || '-' }}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="border-t border-slate-200 px-5 py-4 xl:border-t-0">
        <div class="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">
          Contexto Operacional
        </div>

        <dl class="mt-3 space-y-2.5">
          <div class="flex items-start justify-between gap-4">
            <dt class="text-[12px] text-slate-500">Valor Base (BRL)</dt>
            <dd class="text-right text-[13px] font-semibold text-[#13161b]">
              {{ formatCurrency(summary?.totalAmountBase, 'BRL') }}
            </dd>
          </div>

          <div class="flex items-start justify-between gap-4">
            <dt class="text-[12px] text-slate-500">Atualizado em</dt>
            <dd class="text-right text-[13px] font-semibold text-[#13161b]">
              {{ formatDateTime(summary?.modifiedOn) || '-' }}
            </dd>
          </div>

          <div class="flex items-start justify-between gap-4">
            <dt class="text-[12px] text-slate-500">Entrega Solicitada</dt>
            <dd class="text-right text-[13px] font-semibold text-[#13161b]">
              {{ formatDate(summary?.requestDeliveryBy) || '-' }}
            </dd>
          </div>
        </dl>
      </section>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { useFormat } from '@/composables/useFormat'

defineProps({
  summary: {
    type: Object,
    default: () => ({}),
  },
})

const { formatDate, formatFullDate } = useFormat()

const formatDateTime = (value) => {
  return value ? formatFullDate(value) : ''
}

const formatCurrency = (value, currencyCode = 'BRL') => {
  if (value === null || value === undefined || value === '') return '-'
  const parsed = Number(value)
  if (Number.isNaN(parsed)) return '-'

  try {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: currencyCode || 'BRL',
    }).format(parsed)
  } catch (error) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(parsed)
  }
}
</script>
